import React from 'react';
import {connect} from "react-redux";
import TipsAndTricks from "../../../../../../../../../../../../components/tips-and-tricks/index";
import {guidedTours} from "../../../../../../../../../../../../../actions/guidedToursActions";
import './index.css';

class T2 extends React.Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    t2 = null;

    componentDidMount(){
        setTimeout(() => {
            this.position();

            window.addEventListener('resize', () => {
                this.position()
            });
        }, 500);
    }

    closeHandler(){
        this.t2.style.transform = "scale(0)";
    }

    position(){

        if(document.getElementById("t2")){

            this.t2 = document.getElementById("t2");

            if(document.getElementById("shareContacts")){

                let targetCoord = document.getElementById("shareContacts").getBoundingClientRect();

                /*
                * t4.offsetWidth instead of document.getElementById("t4").getBoundingClientRect().width to keep the initial width and not the one calculated by the scale effect.
                * */

                this.t2.style.left = targetCoord.x - targetCoord.width - this.t2.offsetWidth + "px";
                this.t2.style.top = targetCoord.y + ( (targetCoord.height / 2) - (this.t2.offsetHeight / 2) - 12) + "px";

                setTimeout(() => {
                    this.t2.style.transform = "scale(1)";
                },500);

            }
        }

    }

    render() {

        if(document.getElementById("t2")){
            setTimeout(() => {
                this.position();
                this.t2.style.transform = "scale(1)";
            }, 500);
        }

        return (
            <TipsAndTricks id="t2" dir="right" onClose={this.closeHandler}>
                Click here to share these contacts.
            </TipsAndTricks>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLabelsLoading : state.contactsGroupItemReducer.isLabelsLoading,
        guidedTours : state.guidedToursReducer.guidedTours,
        profile : state.profileReducer.getProfile
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setGuidedTours : (object) => {
            dispatch(guidedTours(object))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(T2);